<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t('translationPriceList'))"
      icon="mdi-cash"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t('translationPriceNew')"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('translationPrice')"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #tools>
      <export-excel
        :data="totals.excel"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      </template>
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="translationPriceListColumnPlugins"
        v-column-drag="translationPriceListColumnPlugins"
        v-column-pin="translationPriceListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        class="mb-0"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y>
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" class="pl-action-cell__btn" icon x-small v-on="on">
                <v-icon medium> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>
                        <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-clipboard:copy="$baseURL + '/translation/price/edit/' + item.uid"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <v-list-item link @click="openDeleteDialog(item)">
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row">{{ parseInt(items.indexOf(item)) + parseInt(from) }}</span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.fee="{ item }">
          {{ $numberFormat(item.fee) }}
        </template>
        <template v-slot:item.special_translation="{ item }">
          {{ $numberFormat(item.special_translation) }}
        </template>
        <template v-slot:item.judicial_approval="{ item }">
          {{ $numberFormat(item.judicial_approval) }}
        </template>
        <template v-slot:item.equal_original="{ item }">
          {{ $numberFormat(item.equal_original) }}
        </template>
        <template v-slot:item.judicial_approval="{ item }">
          {{ $numberFormat(item.judicial_approval) }}
        </template>
        <template v-slot:item.office_services="{ item }">
          {{ $numberFormat(item.office_services) }}
        </template>
        <template v-slot:item.stamp_translator="{ item }">
          {{ $numberFormat(item.stamp_translator) }}
        </template>
        <template v-slot:item.verification_services="{ item }">
          {{ $numberFormat(item.verification_services) }}
        </template>
        <template v-slot:item.inquiry="{ item }">
          {{ $numberFormat(item.inquiry || 0) }}
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="options.page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t('translationPriceList'))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t('translationPriceNew')"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('translationPrice')"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('translationPriceList'))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex pb-0">
          <v-btn icon color="grey darken-2" @click="printDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("print") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="uploadDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <upload
            type-prop="translationPrice"
            :get-item="uploadDialog"
            @close="uploadDialog = false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="exchangeDialog"
      width="700"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="exchangeDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col class="mt-0 pt-0 pr-7">
          <price-exchange @close="exchangeDialog = false" />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
        <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="filter"
      max-width="720"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("translationPriceListFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-translate</v-icon>
              {{ $t("translationPriceFilterMain") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <aicomplete
                v-model="documentType"
                title="documentType"
                type="setConfig"
                :new-btn="true"
                :rules="[(v) => !!v || $t('is-required')]"
                :data="JSON.stringify({ key: 't_docuemtnType', type: 'translation' })"
                :val="documentType"
              />
              <aicomplete
                v-model="fromLanguage"
                title="fromLanguage"
                type="setConfig"
                :rules="[(v) => !!v || $t('is-required')]"
                :new-btn="true"
                :data="JSON.stringify({ key: 't_languages', type: 'translation' })"
                :val="fromLanguage"
              />
              <aicomplete
                v-model="toLanguage"
                title="toLanguage"
                type="setConfig"
                :new-btn="true"
                :rules="[(v) => !!v || $t('is-required')]"
                :data="JSON.stringify({ key: 't_languages', type: 'translation' })"
                :val="toLanguage"
              />
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col class="d-flex">
          <v-btn icon color="grey darken-2" @click="taskDialog = false">
            <v-icon class="close-hover" large> mdi-close </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t("task") }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn icon class="close-hover" @click="deletDialog = false">
            <v-icon color="grey" large> mdi-close </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img class="mx-auto" width="200" src="@/assets/stop.svg" />
        </v-col>
        <v-col class="mt-3 pr-7">
          <p class="mx-auto font-weight-medium">
            {{ $t("are-you-sure-delete-this-case") }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn v-if="selected.length > 0" color="primary" @click="removegroup">
                {{ $t("remove") }}
              </v-btn>
              <v-btn v-if="selected.length == 0" color="primary" @click="remove">
                {{ $t("remove") }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t("cancel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
import Task from "../task/task";
import Print from "../../components/general/Print/Index";
import General from "../../../../Mixins/general";
import aicomplete from "../../components/general/AIcomplete/index";
import Upload from "../../components/general/upload/upload";
import PriceExchange from "./partial/priceExchange";
import {
  applyColumnSettings,
  loadColumnSettings,
} from "@/plugins/columnSettings/columnSettings";
import { reorderPinnedHeaders } from "@/plugins/columnPin/columnPin";
import ProList from "@/Mixins/proList";
import ProListFrame from "@/components/proList/ProListFrame.vue";
import ProListMobile from "@/components/proList/ProListMobile.vue";
import PrintStudio from "@/modules/print/PrintStudio.vue";
export default {
  name: "TranslationList",
  components: {
    ProListFrame,
    ProListMobile,
    PrintStudio,
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    aicomplete,
    Print,
    Upload,
    PriceExchange,
    Task,
  },
  mixins: [General, ProList],
  props: ["input", "refId"],
  data: () => ({
    selected: [],
    pageCount: 1,
    invoicePrintDialog: false,
    exchangeDialog: false,
    uploadDialog: false,
    printDialog: false,
    deletDialog: false,
    documentType: null,
    toLanguage: null,
    fromLanguage: null,
    dialogData: null,
    account: null,
    currencyFilter: null,
    fromAmount: null,
    toAmount: null,
    fromNumber: null,
    toNumber: null,
    fromDate: null,
    toDate: null,
    printId: null,
    showSelect: false,
    filter: false,
    productStatus: null,
    model: null,
    from: 1,
    taskDialog: null,
    tag: null,
    temp: null,
    deleteItem: null,
    sellStatus: null,
    items: [],
    sortBy: [],
    dialog: null,
    timer: 0,
    totalItems: 0,
    snakbar: false,
    typeForm: null,
    taskId: null,
    snakbarText: null,
    loading: true,
    options: {
      itemsPerPage: 5,
    },
    headers: null,
    type: null,
    search: null,
    selectedHeaders: [],
    headersMap: null,
    excelItems: [],
  }),
  computed: {

    activeFilterChips() {
      var app = this;
      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0;
        return v !== null && v !== undefined && v !== "" && v !== "0" && v !== 0;
      };
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0]);
        if (v && typeof v === "object") return v.name || v.text || v.label || "";
        return typeof v === "number" || typeof v === "string" ? String(v) : "";
      };
      var defs = [
        ["documentType", app.$t("documentType")],
        ["fromLanguage", app.$t("fromLanguage")],
        ["toLanguage", app.$t("toLanguage")],
      ];
      return defs
        .filter(function (d) {
          return has(app[d[0]]);
        })
        .map(function (d) {
          return { key: d[0], label: d[1], value: show(app[d[0]]) };
        });
    },
    proListKey() {
      return this.translationPriceListColumnPersistKey;
    },
    proListLocked() {
      return this.translationPriceListLockedColumns;
    },
    translationPriceListColumnPersistKey() {
      return "translation-price-list-columns";
    },
    translationPriceListLockedColumns() {
      var locked = ["actions", "documentType.name"];
      return this.showSelect ? ["__select"].concat(locked) : locked;
    },
    translationPriceListColumnPlugins() {
      var selectHeader = {
        value: "__select",
        text: "",
        width: 32,
        sortable: false,
        pinned: false,
        originalIndex: -1,
      };
      var visible = this.showSelect
        ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || [];
      return {
        headers: this.headers,
        visibleHeaders: visible,
        locked: this.translationPriceListLockedColumns,
        anchor: "documentType.name",
        minWidth: 60,
        persistKey: this.translationPriceListColumnPersistKey,
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    showHeaders() {
      var app = this;
      return this.headers.filter(function (s) {
        if (app.type !== "sell") {
          if (s.value === "pre_invoice") {
          } else {
            return app.selectedHeaders.includes(s);
          }
        } else {
          return app.selectedHeaders.includes(s);
        }
      });
    },
    totals: function () {
      var app = this;
      app.excelItems = [];
      const totals = this.items.reduce(
        (acc, d) => {
          acc.excel.push({
            // type: app.$t(d.type),
            document_type: d.documentType.name,
            from_language: d.fromLanguage.name,
            to_language: d.toLanguage.name,
            fee: app.$numberFormat(d.fee),
            stamp_translator: app.$numberFormat(d.stamp_translator),
            foreign_approval: app.$numberFormat(d.foreign_approval),
            judicial_approval: app.$numberFormat(d.judicial_approval),
            office_services: app.$numberFormat(d.office_services),
            verification_services: app.$numberFormat(d.verification_services),
            special_translation: app.$numberFormat(d.special_translation),
            inquiry: app.$numberFormat(d.inquiry || 0),
            user: d.user ? d.user.name : "",
          });
          return acc;
        },
        {
          excel: [],
          discount: 0,
          tax: 0,
        }
      );
      return totals;
    },
  },
  watch: {
    refId(val, oldVal) {
      // this.items = []
      this.getItems();
    },
    model() {
      this.$emit("input", this.model);
    },
    selected() {
      this.$emit("input", this.selected.text);
      if (this.selected.length > 0) {
        this.model = this.selected[0].text;
        this.temp = this.selected[0].text;
      }
      this.dialog = false;
    },
    search() {
      var app = this;
      app.loading = true;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        app.getItems();
      }, 1000);
    },
    options: {
      handler() {
        var app = this;
        app.sortBy = [];
        app.options.sortBy.map(function (value, key) {
          const index = app.headers.findIndex((h) => h.value === value);
          app.sortBy.push(app.headers[index].table);
        });
        this.getItems();
      },
      deep: true,
    },
    sortBy() {
      const index = this.headers.findIndex((h) => h.value === this.sortBy);
      if (index > -1) {
        this.sortBy = this.headers[index].table;
      }
    },
  },
  activated() {
    this.getItems();
  },
  beforeMount() {
    this.type = "translation";
    this.headers = [
      {
        text: this.$t("#"),
        align: "center",
        sortable: false,
        value: "actions",
        width: 42,
        class: "pl-action-col",
        cellClass: "pl-action-col",
      },
      {
        text: this.$t("documentType"),
        sortable: false,
        value: "documentType.name",
        width: 150,
      },
      {
        text: this.$t("fromLanguage"),
        sortable: false,
        value: "fromLanguage.name",
      },
      {
        text: this.$t("toLanguage"),
        sortable: false,
        value: "toLanguage.name",
      },
      {
        text: this.$t("baseTranslate"),
        sortable: false,
        value: "fee",
      },
      {
        text: this.$t("specialTranslat"),
        sortable: false,
        value: "special_translation",
      },
      {
        text: this.$t("foreignApproval"),
        sortable: false,
        value: "judicial_approval",
      },
      {
        text: this.$t("judicialApproval"),
        sortable: false,
        value: "judicial_approval",
      },
      {
        text: this.$t("officeServices"),
        sortable: false,
        value: "office_services",
      },
      {
        text: this.$t("stampTranslator"),
        sortable: false,
        value: "stamp_translator",
      },
      {
        text: this.$t("equalOriginal"),
        sortable: false,
        value: "equal_original",
      },
      {
        text: this.$t("verificationServices"),
        sortable: false,
        value: "verification_services",
      },
      {
        text: this.$t("inquiry"),
        sortable: false,
        value: "inquiry",
      },
      {
        text: this.$t("registerar"),
        sortable: false,
        value: "user.name",
      },
    ];
    if (this.input) {
      this.model = this.input;
    }
    this.headersMap = this.headers;
    this.selectedHeaders = this.headers;
    reorderPinnedHeaders(this.headers, {
      locked: this.translationPriceListLockedColumns,
      anchor: "documentType.name",
    });
    this.loadTranslationPriceListColumnSettings();
  },
  mounted() {
    // this.getItems()
  },
  methods: {

    resetFilters() {
      var app = this;
      ["documentType", "fromLanguage", "toLanguage"].forEach(function (k) {
        app[k] = null;
      });
    },
    loadTranslationPriceListColumnSettings() {
      var app = this;
      if (!app.headers || !app.headers.length) return;
      loadColumnSettings(app, app.translationPriceListColumnPersistKey).then(
        function (snapshot) {
          if (!snapshot || !snapshot.length) return;
          applyColumnSettings(app.headers, snapshot, {
            locked: app.translationPriceListLockedColumns,
            anchor: "documentType.name",
          });
          app.$forceUpdate();
        }
      );
    },
    openUploadDialog(item) {
      if (this.$root) {
        this.$root.$emit("open-user-file-process", {
          type: "translationPrice",
        });
      }
    },
    openDeleteDialog(item) {
      this.deleteItem = item;
      this.deletDialog = true;
    },
    openTaskDialog(item) {
      this.refId = item.rel_id;
      this.taskId = item.id;
      this.taskDialog = true;
    },
    isEnabled(slot) {
      return this.enabled === slot;
    },
    edit(item) {
      this.$router.push({ name: "translationPriceEdit", params: { id: item.uid } });
    },
    getItems() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "translationPrice", {
          params: {
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            documentType: app.documentType ? app.documentType.id : null,
            fromLanguage: app.fromLanguage ? app.fromLanguage.id : null,
            toLanguage: app.toLanguage ? app.toLanguage.id : null,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
        .then((res) => {
          res = res.data;
          app.items = res.data;
          app.totalItems = res.total;
          app.pageCount = res.last_page;
          app.from = res.from;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    remove() {
      var app = this;
      if (!app.deleteItem) return false;
      app.loading = true;
      app.$axios
        .delete(this.$endpoint + "translationPrice/" + this.deleteItem.id)
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    removegroup() {
      var app = this;
      app.loading = true;
      const delete_items = app.selected.map((item) => item.id);
      app.$axios
        .get(this.$endpoint + "translationPrice", {
          params: {
            deleteItems: delete_items,
          },
        })
        .then((res) => {
          res = res.data;
          app.deletDialog = false;
          app.deleteItem = null;
          app.selected = [];
          app.getItems();
        })
        .catch((err) => {
          this.deletDialog = false;
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";
</style>
